module.exports = __webpack_public_path__ + "media/application/images/icons/plus-teal-560e29c3c1b8a0351659a07b6b1c0887.svg";